export default __webpack_public_path__ + "7c850025726db8640ea25ee0af9aa708.png";